import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import icons from "./icons";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";
import LoadScript from "vue-plugin-load-script";
import ProgressBar from 'vuejs-progress-bar'

Vue.config.productionTip = false;

Vue.use(VueCookie);
Vue.use(LoadScript);
Vue.use(ProgressBar)

// Load http request library
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

axios.interceptors.request.use(
  function(config) {
    // config.headers = { 'Content-Type' : 'application/x-www-form-urlencoded'};
    //let data = config.data;
    if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
      config.data = qs.stringify(config.data);
    }
    config.url = "../api/index.php";
    if (window.location.hostname == "10.10.0.65") {
      config.url = "http://10.10.0.65/solarfox-subscriptions/api/index.php";
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  icons,
  render: (h) => h(App),
}).$mount("#app");
